import React from 'react';
import {Loyalty} from '@homeaway/react-loyalty-module';
import PropTypes from 'prop-types';
import {VIEW_REWARDS_URL} from './constants';
import {
    triggerLoyaltyEarnPresented,
    LOYALTY_WRAPPER_LOCATION,
} from '../../../utils/EDAP/LoyaltyWrapper';

const LoyaltyWrapper = ({loyaltyData}) => {
    if (!loyaltyData?.labels?.earnRewardsLabel) {
        return null;
    }

    const hasBreakdown = !!loyaltyData?.labels?.awardBreakdownLabels;

    return (
        <div className="confirmation-item" name="LoyaltyWrapper">
            <Loyalty
                tier={loyaltyData?.accountDetails?.tier?.name}
                translations={loyaltyData?.labels}
                viewRewardsUrl={VIEW_REWARDS_URL}
                actionLocation={LOYALTY_WRAPPER_LOCATION}
                triggerEdapEvent={triggerLoyaltyEarnPresented}
                hasBreakdown={hasBreakdown}
            />
        </div>
    );
};

LoyaltyWrapper.propTypes = {
    loyaltyData: PropTypes.shape({}),
};

export default LoyaltyWrapper;
